
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class Material extends Resource {
    public override type = 'materials';

    @prop()
    @required()
    public name!: string;

    /** Clase de PrimeIcons con la que se pinta el material en las citas, p. ej. "pi pi-box". */
    @prop()
    public iconClass?: string | null;

    @prop()
    public active: boolean = true;

}
